export default "__VITE_ASSET__sSZqykpH__"